import { render, staticRenderFns } from "./HeroAlt.vue?vue&type=template&id=69ed2e64&"
import script from "./HeroAlt.vue?vue&type=script&lang=js&"
export * from "./HeroAlt.vue?vue&type=script&lang=js&"
import style0 from "./HeroAlt.vue?vue&type=style&index=0&id=69ed2e64&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports